module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm07_ack"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('strong', [_vm._v("A")]), _vm._v("cknowledments")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The author wishes to thank the Mrs. Giles Whiting Foundation and John Simon Guggenheim Foundation for their generous financial support.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also thanks to friends (a random ordering) who have provided their friendship at moments they are not even aware of, who have tolerated and encouraged me for years: William Timberman, the late Ricardo Sánchez, Rick DeMarinis, Annie Proulx, Ixchel Rosal, Armando Villareal, George Keating, Paige Martinez, Elizabeth Hadas, Tish Hinojosa, Francisco Goldman, Elena Castedo, Wendy Lesser, Oscar Casares, Pat Carr, Pat Little Dog, Hettie Jones—and Judy Hottensen, and Morgan Entrekin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Grateful acknowledgment is made to the following magazines where these stories first appeared: "), _c('em', [_vm._v("The New Yorker,")]), _vm._v(" “Maria de Covina” "), _c('em', [_vm._v("ploughshares")]), _vm._v(" “Mayela One Day in 1989,” “The Pillows”; "), _c('em', [_vm._v("DoubleTake,")]), _vm._v(" “Hueco”; "), _c('em', [_vm._v("The Threepenny Review,")]), _vm._v(" “About Tere Who Was in Palomas”; "), _c('em', [_vm._v("New Dog,")]), _vm._v(" “Brisa”; "), _c('em', [_vm._v("The Texas Observer,")]), _vm._v(" “A Painting in Santa Fe.” "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04e883c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm07_ack.vue
// module id = 81
// module chunks = 0